<template>
  <div class="loginPage">
    <div class="content">
      <div class="logo">
        <img src="../assets/login/hylogo.png" />
        <p>招生系统</p>
      </div>
      <div class="registerCon">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
        >
          <el-form-item label="身份证号/护照号" prop="card">
            <el-input v-model="ruleForm.card" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="ruleForm.phone" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="username">
            <el-input v-model="ruleForm.username" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="mail">
            <el-input v-model="ruleForm.mail" autocomplete="off"></el-input>
          </el-form-item>
          <div class="mailNum">
            <span @click="getMailCode">发送验证码</span>
            <el-input
              v-model="ruleForm.mailNum"
              autocomplete="off"
              placeholder="邮箱验证码"
            ></el-input>
          </div>
          <el-form-item label="密码" prop="pass">
            <el-input
              type="password"
              v-model="ruleForm.pass"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input
              type="password"
              v-model="ruleForm.checkPass"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div :style="{ marginLeft: '140px' }">
          <el-button
            class="loginBtn"
            type="primary"
            :loading="loading"
            @click="register()"
            :style="{ width: '320px' }"
            >注 册</el-button
          >
        </div>
      </div>

      <!-- <div class="bottomIMG">
        <img src="../assets/login/bottomIMG.png" />
      </div> -->
    </div>
    <img class="cloudR" src="../assets/login/cloudR.png" />
    <img class="cloudL" src="../assets/login/cloudL.png" />
    <div class="registerbtn" @click="changeRegister()">
      <p>已有账号，点击登录</p>
      <!-- <p>{{
          language
            ? "没有账号？点击注册"
            : "Don't have an account?Create account"
        }}
               </p> -->
    </div>

    <div class="footer">V1.1</div>
  </div>
</template>
<script>
export default {
  data() {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("请输入数字值"));
        } else {
          callback();
        }
      }, 1000);
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.ruleForm.checkPass !== "") {
          this.$refs.ruleForm.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        username: "",
        pass: "",
        card: "",
        checkPass: "",
        mail: "",
        mailNum: "",
        phone: "",
      },
      rules: {
        username: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        card: [{ required: true, message: "请输入身份证号", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
        mail: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
      },
      loading: false,
      mailNum: "",
    };
  },
  methods: {
    handleCommand(command) {
      if (command == "C") {
        this.language = true;
      } else if (command == "E") {
        this.language = false;
      }
    },
    login() {
      this.$router.push("/index");
    },
    changeRegister() {
      //   console.log(11);
      //   this.registerFlag = !this.registerFlag;
      this.$router.push("/");
    },
    // 验证两次输入的密码是否一致

    register() {
      if(this.ruleForm.card == ""){
        this.$message.error("请输入身份证号");
        return false;
      }
      if(this.ruleForm.phone == ""){
        this.$message.error("请输入手机号码");
        return false;
      }
      if(this.ruleForm.username == ""){
        this.$message.error("请输入姓名");
        return false;
      }
      if(this.ruleForm.mail == ""){
        this.$message.error("请输入邮箱地址");
        return false;
      }      
      if(this.ruleForm.pass == ""){
        this.$message.error("请输入密码");
        return false;
      }
      if(this.ruleForm.checkPass == ""){
        this.$message.error("请再次输入密码");
        return false;
      }
      
      this.$http({
        method: "post",
        url: `/RegistrationMagt/api/Register/Register`,
        params: {
          username: this.ruleForm.username,
          mail: this.ruleForm.mail,
          password: this.ruleForm.pass,
          phone: this.ruleForm.phone,
          idcard: this.ruleForm.card,
          type: 1,
          vcode: this.ruleForm.mailNum,
        },
      })
        .then((res) => {
          console.log(res);
          if (res.data.msg == "error") {
            this.$message.error(res.data.response);
          } else if (res.data.msg == "success") {
            this.$allMethods.returnSuccess(res.data.msg, "注册", "请重新登录");
            this.$refs.ruleForm.resetFields();
            this.$router.push("/");
          }
        })
        .catch((_) => {});
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 获取邮箱验证码
    getMailCode() {
      let mail = this.ruleForm.mail;
      //   http://10.168.1.113:5000/
      this.$http({
        method: "post",
        url: `/RegistrationMagt/api/Register/Sendmail`,
        params: {
          Address: mail,
          type: 0,
        },
      })
        .then((res) => {
          console.log(res);
          if (res.data.msg == "success") {
            this.$message.success("验证码已发送,请注意查收");
          }
        })
        .catch((_) => {});
    },
  },
};
</script>
<style scoped>
.loginPage {
  padding-bottom: 50px;
  overflow: auto;
  height: 100vh;
  min-width: 826px;
  background: linear-gradient(
    -0.43000000000001deg,
    rgba(212, 228, 252, 1) 0%,
    rgba(218, 232, 252, 1) 2.87%,
    rgba(235, 242, 254, 1) 13.85%,
    rgba(246, 250, 254, 1) 27.53%,
    rgba(253, 254, 255, 1) 46.72%,
    rgba(255, 255, 255, 1) 100%
  );
}
.content {
  height: 510px;
  width: 800px;
  /* box-shadow: 0px 7px 10px rgba(182, 196, 250, 0.75); */
  margin: 120px auto 0px;
  padding: 20px;
  z-index: 1;
}
.logo {
  height: 60px;
}
.logo img {
  display: inline-block;
  height: 60px;
}
.logo p {
  display: inline-block;
  position: relative;
  left: 40px;
  top: -20px;
  font-size: 26px;
  font-weight: 700;
}
.loginCon {
  width: 40%;
  margin: 30px auto 10px;
  height: 300px;
  z-index: 3;
}
.registerCon {
  width: 60%;
  margin: 30px auto 10px;
  z-index: 3;
  position: relative;
  top: 0px;
}

.registerbtn {
  color: #2d76f9;
  font-size: 12px;
  height: 24px;
  z-index: 2;
  margin-left: 140px;
  margin-top: 50px;
}
.registerbtn:hover {
  text-decoration: underline;
  cursor: pointer;
}
.speace {
  margin: 15px 0px;
}

.loginBtn {
  width: 100%;
  margin: 12px 0px !important;
  background-color: #2d76f9 !important;
  border-color: #2d76f9 !important;
  font-size: 14px !important;
  border-radius: 12px;
}
.bottomIMG {
  position: absolute;
  height: 200px;
  width: 900px;
  margin: auto;
  bottom: 250px;
  z-index: 1;
  /* background: url("../assets/login/bottomIMG2.png") no-repeat top; */
  background-size: 100% auto;
}
.bottomIMG img {
  z-index: 1;
  width: 980px;
  position: relative;
  left: -100px;
}
.footer {
  background: #2d76f9;
  height: 30px;
  width: 100%;
  min-width: 1200px;
  position: absolute;
  bottom: 0px;
  color: #0095ff;
  text-align: left;
}
.changelanguage {
  position: fixed;
  top: 30px;
  right: 50px;
  cursor: pointer;
}
.cloudR {
  position: relative;
  left: 500px;
  top: -520px;
}
.cloudL {
  position: relative;
  left: -800px;
  top: -300px;
}
.mailNum {
  margin: 20px 0px;
  text-align: right;
}
.mailNum span {
  color: #2d76f9;
  font-size: 12px;
  cursor: pointer;
}
</style>
<style>
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.mailNum > .el-input {
  display: inline-block;
  width: 240px;
  margin-left: 40px;
}
</style>